module.exports = __webpack_public_path__ + "static/media/SAT-BNB.08672d7d.png";